<div
  style="
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    overflow: auto;
  "
>
  <ng-container *ngIf="isLoading; else noDataTemplate">
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  </ng-container>

  <ng-template #noDataTemplate>
    <ng-container *ngIf="!(listData && listData.length > 0); else listTemplate">
      <p style="text-align: center">No data retrieved from server</p>
      <!-- Project the no-data content -->
    </ng-container>
  </ng-template>

  <ng-template #listTemplate>
    <ng-content *ngIf="showTitle" select="[htmlTitle]"></ng-content>
    <h4
      *ngIf="showTitleFromDashboard"
      class="chart-title"
      style="
        margin: 0 0 15px 0;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      "
    >
      {{ title }}
    </h4>
    <mat-form-field class="global-filter" *ngIf="settings?.showFilter">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyGlobalFilter($event.target)"
        placeholder="Type to Filter Results"
      />
    </mat-form-field>
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="mat-elevation-z8"
      multiTemplateDataRows
    >
      <ng-container
        *ngFor="let column of displayedColumns"
        [matColumnDef]="column"
      >
        <!-- Primary rows -->
        <ng-container
          *ngIf="
            column !== 'toggle' && !column.startsWith('__action_');
            else specialColumn
          "
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column | titlecase }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row[column] }}</td>
        </ng-container>
        <ng-template #specialColumn>
          <ng-container *ngIf="column === 'toggle'; else actionColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <i
                class="fa chevron-icon"
                [class.fa-chevron-up]="isRowExpanded(row)"
                [class.fa-chevron-down]="!isRowExpanded(row)"
                aria-hidden="true"
              ></i>
            </td>
          </ng-container>
          <ng-template #actionColumn>
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <!-- Handle action columns, switch based on cell content -->
              <ng-container
                [ngSwitch]="row[column]?.actionComponent || row[column]"
              >
                <ng-container *ngSwitchCase="'annotation_buttons'">
                  <annotation-buttons
                    [annotationId]="
                      row[column]?.annotationId || row.Id || row.annotationId
                    "
                    [documentId]="
                      row[column]?.documentId ||
                      row.DocumentId ||
                      row.Document?.Id
                    "
                    [isPDF]="
                      row[column]?.isPDF !== undefined
                        ? row[column].isPDF
                        : row.IsPDF
                    "
                  >
                  </annotation-buttons>
                </ng-container>
                <ng-container *ngSwitchCase="'example_buttons'">
                  <!-- Add your buttons component here -->
                  <!-- Example: <example-buttons [rowData]="row"></example-buttons> -->
                  <div>Buttons Placeholder</div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <!-- Default case for unknown action types -->
                  <div>
                    Unknown Action:
                    {{ row[column]?.actionComponent || row[column] }}
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </ng-template>
        </ng-template>
      </ng-container>

      <!-- Secondary rows -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          [attr.colspan]="displayedColumns.length"
          *matCellDef="let row"
          [class.hidden]="secondaryColumns.length <= 0"
          class="expanded-detail-cell"
        >
          <div *ngIf="isRowExpanded(row)">
            <div
              *ngFor="let column of secondaryColumns"
              class="expanded-row-content"
            >
              <span class="secondary-column-title">
                {{ column.replace("__secondary_", "") }}
              </span>
              <analytics-display-list-simple
                [listData]="row[column]"
              ></analytics-display-list-simple>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="toggleRow(row)"
        [class.demo-row-is-clicked]="isRowExpanded(row)"
      ></tr>

      <!-- Expanded row -->
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="expanded-row"
        [class.hidden]="secondaryColumns.length <= 0 || !isRowExpanded(row)"
      ></tr>
    </table>
    <mat-paginator
      [class.hidden]="!(settings && settings.paginate)"
      [pageSize]="settings.pageSize || defaultPageSize"
      [pageSizeOptions]="pageSizeOptions"
      aria-label="Select page"
    >
    </mat-paginator>
  </ng-template>
</div>
